import { useState } from "react";
import { connect } from "react-redux";
import Item from "./components/Item";
import { Button } from "expano-components";
import CreateIssueModal from "./components/CreateIssueModal";

const GdnErrors = ({ id, can_create_error, gdn_user_errors }) => {
  const [is_open_issue_modal, setOpenIssueModal] = useState(false);

  return (
    <div className="dashboard m-b-10">
      <header className="dashboard__header dashboard__header--edit">
        <h2 className="dashboard__title heading">Błędy zamówienia</h2>
        {can_create_error && (
          <Button
            type="add"
            text="Zgłoś błąd zamówienia"
            onClick={() => setOpenIssueModal(true)}
          />
        )}
      </header>
      {is_open_issue_modal && (
        <CreateIssueModal
          gdn_id={id}
          handleClose={() => setOpenIssueModal(false)}
        />
      )}

      <ul className="dashboard__list">
        {gdn_user_errors.map((item) => (
          <Item key={item?.id} {...item} />
        ))}
      </ul>
    </div>
  );
};

const mapStateToProps = ({
  gdn: {
    data: { gdn_user_errors, status },
  },
}) => ({
  gdn_user_errors: gdn_user_errors.filter(({ kind }) =>
    [
      "packer_incorrect_photo",
      "packer_packing_other",
      "packer_badly_packed",
      "picker_over_packed",
      "packer_double_cod",
      "packer_skip_note",
      "packer_extra_products",
      "packer_unreceived_packages_to_verify",
      "packer_wrong_package_label_not_deleted",
    ].includes(kind)
  ),
  can_create_error: ["completed", "need_verification"].includes(status),
});

export default connect(mapStateToProps, null)(GdnErrors);
